import { render, staticRenderFns } from "./GFRegisteredList.vue?vue&type=template&id=8cfab2e2"
import script from "./GFRegisteredList.vue?vue&type=script&lang=js"
export * from "./GFRegisteredList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports